let openSidebars = [];

function openSidebar(sidebarId, btn) {
    const sidebar = document.getElementById(sidebarId);
    const overlay = document.getElementById('overlay');

    if (sidebar.classList.contains("sidebar-3") && btn) {
        const sidebarHeadingElem = sidebar.querySelector(".sidebar-heading");
        const sidebarSubHeadingElem = sidebar.querySelector(".sidebar-subheading");
        const sidebarDescriptionElem = sidebar.querySelector(".sidebar-description");
        const sidebarBuyBtnsContainer = sidebar.querySelector(".buy-btns");

        const sidebarHeaderContent = btn.getAttribute("data-heading-text");
        const sidebarSubHeadingContent = btn.getAttribute("data-subheading-text");
        const sidebarDescriptionContent = btn.getAttribute("data-description-text");
        const sidebarBtn1label = btn.getAttribute("data-button1-label");
        const sidebarBtn1link = btn.getAttribute("data-button1-link");
        const sidebarBtn2label = btn.getAttribute("data-button2-label");
        const sidebarBtn2link = btn.getAttribute("data-button2-link");
        const sidebarBtn3label = btn.getAttribute("data-button3-label");
        const sidebarBtn3link = btn.getAttribute("data-button3-link");
        const sidebarBtn4label = btn.getAttribute("data-button4-label");
        const sidebarBtn4link = btn.getAttribute("data-button4-link");

        sidebarHeadingElem.innerHTML = sidebarHeaderContent;
        sidebarSubHeadingElem.innerHTML = sidebarSubHeadingContent;
        sidebarDescriptionElem.innerHTML = sidebarDescriptionContent;

        let hasTwoBtns = sidebarBtn1link && sidebarBtn2link;

        if(sidebarBtn1link){
            const buyBtn1Elem = `
                    <a href="${sidebarBtn1link}" class="buy-btn button ${hasTwoBtns ? 'btn-fxd-width' : ''}">
                        <span>
                            ${sidebarBtn1label}
                        </span>
                    </a>                    
            `;
            sidebarBuyBtnsContainer.insertAdjacentHTML('beforeend', buyBtn1Elem);
        }
        if(sidebarBtn2link){
            const buyBtn2Elem = `
                    <a href="${sidebarBtn2link}" class="buy-btn button ${hasTwoBtns ? 'btn-fxd-width' : ''}">
                        <span>
                            ${sidebarBtn2label}
                        </span>
                    </a>                    
            `;
            sidebarBuyBtnsContainer.insertAdjacentHTML('beforeend', buyBtn2Elem);
        }
        if(sidebarBtn3link){
            const buyBtn3Elem = `
                    <a href="${sidebarBtn3link}" class="buy-btn button ${hasTwoBtns ? 'btn-fxd-width' : ''}">
                        <span>
                            ${sidebarBtn3label}
                        </span>
                    </a>                    
            `;
            sidebarBuyBtnsContainer.insertAdjacentHTML('beforeend', buyBtn3Elem);
        }
        if(sidebarBtn4link){
            const buyBtn4Elem = `
                    <a href="${sidebarBtn4link}" class="buy-btn button ${hasTwoBtns ? 'btn-fxd-width' : ''}">
                        <span>
                            ${sidebarBtn4label}
                        </span>
                    </a>                    
            `;
            sidebarBuyBtnsContainer.insertAdjacentHTML('beforeend', buyBtn4Elem);
        }
    }
    
    if (!sidebar.classList.contains('open')) {
        sidebar.classList.add('open');
        openSidebars.push(sidebarId);
        
        // Show overlay only for the first sidebar
        if (openSidebars.length === 1) {
            overlay.classList.add('active');
            // document.body.classList.add('open-cc');
        }
    }
}

function closeSidebar(sidebarId) {
    const sidebar = document.getElementById(sidebarId);
    const overlay = document.getElementById('overlay');

    if (sidebar.classList.contains("sidebar-3")){
        const sidebarBuyBtnsContainer = sidebar.querySelector(".buy-btns");
        sidebarBuyBtnsContainer.innerHTML = ''
    }
    
    if (sidebar.classList.contains('open')) {
        sidebar.classList.remove('open');
        
        // Remove from openSidebars array
        const index = openSidebars.indexOf(sidebarId);
        if (index > -1) {
            openSidebars.splice(index, 1);
        }
        
        // Close all sidebars that were opened after this one
        const sidebarNumber = parseInt(sidebarId.replace('sidebar', ''));
        for (let i = sidebarNumber + 1; i <= 3; i++) {
            const nextSidebar = document.getElementById('sidebar' + i);
            if (nextSidebar && nextSidebar.classList.contains('open')) {
                nextSidebar.classList.remove('open');
                const nextIndex = openSidebars.indexOf('sidebar' + i);
                if (nextIndex > -1) {
                    openSidebars.splice(nextIndex, 1);
                }
            }
        }
        
        // Hide overlay if no sidebars are open
        if (openSidebars.length === 0) {
            overlay.classList.remove('active');
            // document.body.classList.remove('open-cc');
        }
    }
}

// Close sidebars when clicking on overlay
document.getElementById('overlay').addEventListener('click', function() {
    // Close all open sidebars
    openSidebars.forEach(sidebarId => {
        document.getElementById(sidebarId).classList.remove('open');
    });
    openSidebars = [];
    this.classList.remove('active');
});

// Close sidebars with Escape key
document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && openSidebars.length > 0) {
        // Close the topmost sidebar
        const topSidebar = openSidebars[openSidebars.length - 1];
        closeSidebar(topSidebar);
    }
});

// Prevent body scroll when sidebar is open
function updateBodyScroll() {
    if (openSidebars.length > 0) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = 'auto';
    }
}

// Update body scroll whenever sidebars change
const observer = new MutationObserver(updateBodyScroll);
document.querySelectorAll('.sidebar').forEach(sidebar => {
    observer.observe(sidebar, { attributes: true, attributeFilter: ['class'] });
});